import Fuse, { FuseResult } from "fuse.js";
import { useMemo } from "react";

export type Weights<T extends keyof any = string> = Partial<Record<T, number>>;
export const getKeysFromWeights = (weights: Weights) =>
  Object.entries(weights).map(([name, weight]) => ({
    name,
    weight: weight ?? 0,
  }));

export const createSearch = <T extends object>(
  items: T[],
  weights: Weights<keyof T>
) => {
  const fuse = new Fuse(items, {
    includeMatches: true,
    keys: getKeysFromWeights(weights),
    includeScore: true,
    threshold: 0.2,
  });

  return (query: string) =>
    fuse.search(query).map((result: FuseResult<T>) => {
      const item = result.item as T;
      return { item, matches: result.matches, score: result.score };
    });
};

export const useSearch = <T extends object>(
  items: T[],
  weights: Weights<keyof T>
) => {
  return useMemo(() => createSearch(items, weights), [items, weights]);
};
